import React from "react";
import { imgUrl } from "../lib/api";

// Client logo or initials fallback
const RefLogo = ({ name, logo, size = "md", dark = false }) => {
  const box = size === "lg" ? "h-16 w-16 text-xl" : size === "sm" ? "h-9 w-9 text-xs" : "h-12 w-12 text-sm";
  if (logo) {
    return (
      <img
        src={imgUrl(logo)}
        alt={name}
        className={`${box} rounded-xl object-contain ${dark ? "bg-white/5" : "bg-white"} p-1.5 border ${dark ? "border-white/10" : "border-slate-200"}`}
      />
    );
  }
  const initials = name
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
  return (
    <div
      className={`${box} rounded-xl flex items-center justify-center font-display font-bold shrink-0 ${
        dark ? "bg-amber-500/15 text-amber-400 border border-amber-500/20" : "bg-navy-900 text-amber-400"
      }`}
    >
      {initials}
    </div>
  );
};

export default RefLogo;
